import { createContext, useEffect, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  useEffect(() => {
    console.log("MOUNT AuthProvider");
    return () => console.log("UNMOUNT AuthProvider");
  }, []);
  const [userInfo, setUserInfo] = useState();
  const [accessToken, setAccessToken] = useState();

  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const [mobileSidebar, setMobileSidebar] = useState(false);
  const toggleMobileSidebar = () => {
    setMobileSidebar(!mobileSidebar);
  };

  const isLoggedIn = async () => {
    try {
      let user_info = await window.sessionStorage.getItem("userInfo");
      user_info = JSON.parse(user_info);

      if (user_info) {
        setUserInfo(user_info);
      }

      let access_token = await window.sessionStorage.getItem("accessToken");
      access_token = JSON.parse(access_token);

      if (access_token) {
        setAccessToken(access_token);
      }
    } catch (e) {}
  };

  useEffect(() => {
    isLoggedIn();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        userInfo,
        setUserInfo,
        accessToken,
        setAccessToken,
        showSidebar,
        setShowSidebar,
        toggleSidebar,
        mobileSidebar,
        setMobileSidebar,
        toggleMobileSidebar,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
